module.exports = __webpack_public_path__ + "img/payrate3.145d07ae.jpg";